var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconPresent40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_20884)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3033 6.50293C16.5341 6.50293 19.8584 13.1381 19.8584 13.1381V16.1302C19.6107 16.1302 19.3703 16.1281 19.1326 16.125C9.49606 16.0016 8.03171 13.4119 7.80964 11.8386C7.77675 11.604 7.77112 11.392 7.77019 11.2142L7.77002 11.0875C7.77002 9.78854 8.07212 6.50293 12.3033 6.50293ZM20.5345 16.1288L20.1677 16.1302V13.1381C20.1677 13.1381 23.4923 6.50293 27.7228 6.50293C31.954 6.50293 32.2561 9.78854 32.2561 11.0875C32.2561 11.2874 32.2579 11.5453 32.2163 11.8385C31.9947 13.4119 30.5301 16.0016 20.8936 16.1251L20.5345 16.1288Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4365 13.8213C23.4365 15.7542 21.8695 17.3213 19.9362 17.3213C18.0035 17.3213 16.4365 15.7542 16.4365 13.8213C16.4365 11.8884 18.0035 10.3213 19.9362 10.3213C21.8695 10.3213 23.4365 11.8884 23.4365 13.8213Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27077 19.5029H32.7292C33.4311 19.5029 34 18.9441 34 18.2549V15.751C34 15.0617 33.4311 14.5029 32.7292 14.5029H7.27077C6.56894 14.5029 6 15.0617 6 15.751V18.2549C6 18.9441 6.56894 19.5029 7.27077 19.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.298 34.5029H31.702C32.4189 34.5029 33 33.9441 33 33.2549V19.5029H7V33.2549C7 33.9441 7.58113 34.5029 8.298 34.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 29.1423L17.5409 30.5015C17.535 30.5047 17.5277 30.5023 17.5246 30.4962C17.5234 30.4937 17.523 30.4909 17.5234 30.4881L17.9931 27.6094L16.0036 25.5707C15.9989 25.5658 15.9988 25.5578 16.0034 25.5528C16.0053 25.5508 16.0077 25.5495 16.0103 25.5491L18.7597 25.1291L19.9892 22.51C19.9921 22.5037 19.9994 22.5011 20.0053 22.5042C20.0077 22.5055 20.0096 22.5075 20.0108 22.51L21.2403 25.1291L23.9897 25.5491C23.9963 25.5501 24.0008 25.5565 23.9999 25.5635C23.9995 25.5662 23.9983 25.5688 23.9964 25.5707L22.0069 27.6094L22.4766 30.4881C22.4777 30.495 22.4733 30.5016 22.4667 30.5027C22.4641 30.5032 22.4614 30.5028 22.4591 30.5015L20 29.1423Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_20884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconPresent40);
export default __webpack_public_path__ + "static/media/pictogramBeaconPresent40.f70a2d4f9e2876625f681efc36a8f416.svg";
export { ForwardRef as ReactComponent };